import Badge from "hardcover-ui/components/Badge";
import Icon from "hardcover-ui/components/Icon";
import { BadgeThemeProps } from "hardcover-ui/theme/components/badge";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "hardcover-ui/components/Tooltip";
import sparkles from "icons/solid/sparkles.svg";
import { useState } from "react";
import TextLink from "hardcover-ui/components/TextLink";

interface BookMatchPercentageForUser {
  matchScore?: number;
  size?: BadgeThemeProps["size"];
}

export default function MatchPercentageBadge({
  size = "sm",
  matchScore,
}: BookMatchPercentageForUser) {
  const [isOpen, setIsOpen] = useState(false);

  if (!matchScore) {
    return false;
  }

  return (
    <TooltipProvider>
      <Tooltip open={isOpen} onOpenChange={setIsOpen}>
        <TooltipTrigger asChild>
          <Badge 
            variant="accent" 
            size={size} 
            className="space-x-1 inline cursor-help"
            tabIndex={0}
            role="button"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setIsOpen(true);
              }
            }}
          >
            <Icon icon={sparkles} size="sm" />
            <span>{matchScore}%</span>
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p>This book's <TextLink href="/blog/match-percentage">match percentage</TextLink></p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
